
export const VersionService = {
    version: 0,
    get() {
        return this.version;
    },
    set(newVersion) {
        return this.version = newVersion;
    }   
};
